export const MEDIA_QUERY_MOBILE = "(min-width: 0) and (max-width: 767px)";

export const MEDIA_QUERY_MOBILE_DROPDOWN =
  "(min-width: 0) and (max-width: 1023px)";

export const MEDIA_QUERY_TABLET = "(min-width: 768px) and (max-width: 1023px)";

export const MEDIA_QUERY_DESKTOP_SMALL =
  "(min-width: 1024px) and (max-width: 1375px)";

export const MEDIA_QUERY_DESKTOP =
  "(min-width: 1376px) and (max-width: 1799px)";

export const MEDIA_QUERY_DESKTOP_DROPDOWN = "(min-width: 1024px)";

export const MEDIA_QUERY_DESKTOP_LARGE = "(min-width: 1800px)";

export const MEDIA_QUERIES = {
  desktop: MEDIA_QUERY_DESKTOP,
  desktop_dropdown: MEDIA_QUERY_DESKTOP_DROPDOWN,
  desktop_large: MEDIA_QUERY_DESKTOP_LARGE,
  desktop_small: MEDIA_QUERY_DESKTOP_SMALL,
  mobile_dropdown: MEDIA_QUERY_MOBILE_DROPDOWN,
  mobile: MEDIA_QUERY_MOBILE,
  tablet: MEDIA_QUERY_TABLET,
};
